import { parseNumber, parseString, transformModel } from '~/src/dash/api/resource-transforms';
import {
  addDomainAndTokenToUrl,
  IHttpResponse,
  restDelete,
  restGet,
  restPatch,
  restPost,
} from '~/src/dash/api/rest';

export interface IAPSPriceMapPair {
  ID: number;
  CreatedAt?: string;
  UpdatedAt?: string;
  DeletedAt?: string;

  PublisherID: number;
  PriceKey: string;
  PriceValue: number;
}

export const transformAPSPriceMapPair = transformModel<IAPSPriceMapPair>({
  ID: parseNumber(['ID']),
  CreatedAt: 'CreatedAt',
  UpdatedAt: 'UpdatedAt',
  DeletedAt: 'DeletedAt',

  PublisherID: parseNumber(['PublisherID']),
  PriceKey: parseString(['PriceKey']),
  PriceValue: parseNumber(['PriceValue']),
});

// GET all APSPriceMapPairs for this publisher
// /publishers/{publisherID}/aps_price_map_pairs
export async function getAPSPriceMapPairs(publisherID: string): Promise<IAPSPriceMapPair[]> {
  const reqUrl = addDomainAndTokenToUrl(`/publishers/${publisherID}/aps_price_map_pairs`);
  return await restGet<IAPSPriceMapPair[]>(reqUrl, {}).then(
    (val: IHttpResponse<IAPSPriceMapPair[]>) => {
      return val.parsedBody ? val.parsedBody.map(transformAPSPriceMapPair) : [];
    },
  );
}

// PATCH, DELETE a single pair
// /publishers/{publisherID}/aps_price_map_pairs/{aps_price_map_pairs_id}

export async function updateAPSPriceMapPair(
  pair: IAPSPriceMapPair,
  publisherID: string,
): Promise<IAPSPriceMapPair> {
  const partialUrl = addDomainAndTokenToUrl(
    `/publishers/${publisherID}/aps_price_map_pairs/${pair.ID}`,
  );
  const parsedPair = transformAPSPriceMapPair(pair);
  return await restPatch<IAPSPriceMapPair>(partialUrl, parsedPair).then(
    (val: IHttpResponse<IAPSPriceMapPair>) => {
      return transformAPSPriceMapPair(val.parsedBody);
    },
  );
}

export async function deleteAPSPriceMapPair(
  pairID: number,
  publisherID: string,
): Promise<IHttpResponse<{ status: boolean }>> {
  const reqUrl = addDomainAndTokenToUrl(`/publishers/${publisherID}/aps_price_map_pairs/${pairID}`);
  return await restDelete<{ status: boolean }>(reqUrl, undefined);
}

// POST a single pair
// /publishers/{publisherID}/aps_price_map_pairs
export async function createAPSPriceMapPair(
  pair: IAPSPriceMapPair,
  publisherID: string,
): Promise<IAPSPriceMapPair> {
  const reqUrl = addDomainAndTokenToUrl(`/publishers/${publisherID}/aps_price_map_pairs`);
  const parsedPair = transformAPSPriceMapPair(pair);
  return await restPost<IAPSPriceMapPair>(reqUrl, parsedPair).then(
    (val: IHttpResponse<IAPSPriceMapPair>) => {
      return transformAPSPriceMapPair(val.parsedBody);
    },
  );
}
